/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConversationsCreateRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  createConversationRequest: components.CreateConversationRequest;
};

/** @internal */
export const ConversationsCreateRequest$inboundSchema: z.ZodType<
  ConversationsCreateRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  CreateConversationRequest: components.CreateConversationRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "CreateConversationRequest": "createConversationRequest",
  });
});
/** @internal */
export type ConversationsCreateRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  CreateConversationRequest: components.CreateConversationRequest$Outbound;
};

/** @internal */
export const ConversationsCreateRequest$outboundSchema: z.ZodType<
  ConversationsCreateRequest$Outbound,
  z.ZodTypeDef,
  ConversationsCreateRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  createConversationRequest:
    components.CreateConversationRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    createConversationRequest: "CreateConversationRequest",
  });
});

export function conversationsCreateRequestToJSON(
  conversationsCreateRequest: ConversationsCreateRequest,
): string {
  return JSON.stringify(
    ConversationsCreateRequest$outboundSchema.parse(conversationsCreateRequest),
  );
}
export function conversationsCreateRequestFromJSON(
  jsonString: string,
): SafeParseResult<ConversationsCreateRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConversationsCreateRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConversationsCreateRequest' from JSON`,
  );
}
